import React from 'react'
import ResourceFilter from 'support/filters/ResourceFilter'
import { useTranslation } from '@morningtrain/react-translations'
import {SelectedDepartmentFilter} from "support/filters/index";
import {StaticFilter} from "@morningtrain/react-filters";

function SupplierFilter (props) {
  const label = useTranslation('filters.supplier.label')
  const placeholder = useTranslation('filters.supplier.placeholder')

  return (
    <ResourceFilter
      {...props}
      resourceName='inventory.supplier'
      optionsKey='name'
      label={label}
      isSearchable={false}
      placeholder={placeholder}
      name='supplier_id'>
      <SelectedDepartmentFilter/>
      <StaticFilter name='without_ordered' value={1}/>
    </ResourceFilter>
  )
}

SupplierFilter.propTypes = {
  ...ResourceFilter
}

export default SupplierFilter
